import clsx from "clsx";
import React from "react";
import Button from "../components/common/Button";
import Title from "../components/common/Title";

export type ErrorPageProps = {
} & React.HTMLAttributes<HTMLDivElement>

function ErrorPage({
  className,
  ...rest
}: ErrorPageProps) {
  return (
    <div className={clsx(className, "flex flex-col bg-lands bg-cover  h-screen w-screen")} {...rest}>
      <div className='flex flex-col h-full justify-center items-center'>
        <div className="flex flex-col items-center justify-center w-screen h-screen bg-eternity-lands bg-cover p-4">
          <img className="max-w-container-sm lg:max-w-xl" src="/logo.webp" alt="Eternity logo" />
          <div className="flex flex-col gap-2 items-center mt-4 md:mt-24">
            <Title className="font-bold text-title-lg">Something went wrong</Title>
            <a href="/authorize">
              <Button size="xl">
                Return to safety
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage;